export default __webpack_public_path__ + "static/media/ram.20fa73be.svg";